import { fetchJson } from 'utils/fetchJson/fetchJson';

const geolocation = {
  fetch: () => {
    return fetchJson<{ countryCode: string }>('/localize');
  },
};

export { geolocation };
